import type { RequiredGeneric } from '@pba/react-utils';
import type { EducationLevel, Interest, Profession } from 'models';
import { Col, Fieldset, Form, Input, Row, Select, TextArea } from 'ui';

export type OtherDetailsFormValues = {
  biography?: string;
  company?: string;
  educationLevel?: string;
  interests?: string[];
  profession?: string;
};

type P = {
  educationLevels: EducationLevel[];
  interests: Interest[];
  professions: Profession[];
};

const OtherDetailsFieldset = <FormValues extends OtherDetailsFormValues = never>({
  educationLevels,
  interests,
  professions,
}: RequiredGeneric<FormValues, P>) => (
  <Fieldset legend={{ title: 'Other Details' }}>
    <Row>
      <Col span={24}>
        <Form.Item<OtherDetailsFormValues> label="Education level" name="educationLevel">
          <Select
            optionFilterProp="label"
            options={educationLevels.map((education) => ({
              label: education.name,
              value: education.id,
            }))}
            showSearch
          />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item<OtherDetailsFormValues> label="Profession" name="profession">
          <Select
            optionFilterProp="label"
            options={professions.map((profession) => ({
              label: profession.name,
              value: profession.id,
            }))}
            showSearch
          />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item<OtherDetailsFormValues> label="Company / school" name="company">
          <Input />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item<OtherDetailsFormValues> label="Biography" name="biography">
          <TextArea rows={4} />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item<OtherDetailsFormValues> extra="You can choose multiple options" label="Interests" name="interests">
          <Select
            maxCount={3}
            mode="multiple"
            optionFilterProp="label"
            options={interests.map((interest) => ({
              label: interest.name,
              value: interest.id,
            }))}
            showSearch
          />
        </Form.Item>
      </Col>
    </Row>
  </Fieldset>
);

export default OtherDetailsFieldset;
